import dayjs, { Dayjs } from 'dayjs';
import { Contract } from 'entities/Contract';
import { VerificationDocument, VerificationFileStatus } from 'entities/VerificationPhoto';

export const hasPendingMoveOutPhotos = (moveOutDocs: VerificationDocument[]): boolean =>
  moveOutDocs.some((doc) => doc.fileStatus === VerificationFileStatus.PENDING);

export const hasUnapprovedMoveOutPhotos = (moveOutDocs: VerificationDocument[]): boolean =>
  moveOutDocs.some((doc) => doc.fileStatus !== VerificationFileStatus.APPROVED);

export const isCloseContractBlocked = (moveOutDocs: VerificationDocument[], hasExtendedClosePermission: boolean): boolean => {
  if (!moveOutDocs.length) {
    return false;
  }

  return hasExtendedClosePermission ? hasPendingMoveOutPhotos(moveOutDocs) : hasUnapprovedMoveOutPhotos(moveOutDocs);
};

export const getCloseContractMinDate = (contract: Contract, hasExtendedClosePermission: boolean): Dayjs => {
  if (hasExtendedClosePermission) {
    return dayjs(contract.createdAt).startOf('day');
  }

  return dayjs(contract.initialEndDate).subtract(1, 'day').startOf('day');
};

export const getCloseContractDisabledDate = (
  contract: Contract,
  hasExtendedClosePermission: boolean,
): ((currentDate: Dayjs) => boolean) => {
  const minDate = getCloseContractMinDate(contract, hasExtendedClosePermission);

  return (currentDate: Dayjs): boolean => currentDate.isBefore(minDate, 'day');
};

export const getDefaultCloseDate = (contract: Contract, hasExtendedClosePermission: boolean): Dayjs => {
  const today = dayjs().startOf('day');
  const minDate = getCloseContractMinDate(contract, hasExtendedClosePermission);

  return today.isBefore(minDate, 'day') ? minDate : today;
};
